// extracted by mini-css-extract-plugin
module.exports = {"cardFooter":"CardFooter_cardFooter__MJfYB","languages":"CardFooter_languages__3GiID","language":"CardFooter_language__2O5Uz","plus":"CardFooter_plus__3VvRc"};